import React, { useEffect, useState } from 'react';
import { BsRobot, BsPeople, BsSearch, BsPlus } from 'react-icons/bs';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import AgentModal from '../../Modal/AgentChatModal';
import { useEmployeeStream } from '../../hooks/EmployeStream';
// import { employees } from '../../data/emp_details';
import { useAuth } from '../../context/AuthContext';

const Home = () => {
  // console.log(Object.values(employees))
  const {user, shouldClearCache, setShouldClearCache} = useAuth();

  const {clearCache} = useEmployeeStream(`${process.env.REACT_APP_PUBLIC_API_BASE_URL}/v1/employees/employees/stream`)
  useEffect(() => {
    if (user.is_superuser && shouldClearCache) {
      clearCache();
      setShouldClearCache(false);
    }
  }, [shouldClearCache]);
  function getDataRange(alldata, start = 0, end = 100) {
    const keys = Object.keys(alldata);
  
    const result = keys
      .slice(start, end) // ✅ pick range from start to end
      .map((key) => ({
        ...alldata[key],
      }));
  
    console.log(`Showing records ${start} to ${end - 1} (total ${result.length})`);
    console.log(result);
    return result;
  }
  const featureRoutes = [
    {
      title: "Onboarding",
      description: "Onboard new employees",
      icon: <BsPlus size={24} />,
      link: "/onboarding"
    },
    {
      title: "Employee CheckList",
      description: "Employe Document Check List",
      icon: <BsSearch size={24} />,
      link: "/checklist"
    },
    {
      title: "Employee Directory",
      description: "Browse through all employees",
      icon: <BsPeople size={24} />,
      link: "/employees"
    },
    {
      title: "AI Assistant",
      description: "Get help from our AI assistant",
      icon: <BsRobot size={24} />,
      link: "/agent-chat"
    }
  ];
  const features = user.is_superuser?featureRoutes:[]

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <AgentModal isOpen={isOpen} onClose={() => setIsOpen(false)} agentType="ci-cd" title="AI Assistant" size="xl" type="default" />
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white rounded-xl p-8 mb-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-4">Welcome to Talent Repo AI</h1>
          <p className="text-xl mb-8">Your intelligent employee management solution</p>
          
          <div className="flex justify-center space-x-4">
            {user.is_superuser && <Link 
              to="/employees" 
              className="bg-white text-indigo-700 px-6 py-3 rounded-lg font-medium hover:bg-indigo-50 transition-colors"
            >
              View Employees
            </Link>}
            <button className="bg-indigo-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-800 transition-colors">
              Get Started
            </button>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <motion.div 
        className="grid md:grid-cols-2 gap-6 mt-12"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {features.map((feature, index) => (
          <motion.div 
            key={index} 
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow"
            variants={itemVariants}
          >
            <div className="text-indigo-600 mb-4">
              {feature.icon}
            </div>
            <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
            <p className="text-gray-600 mb-4">{feature.description}</p>
            <Link 
              to={feature.link}
              className="text-indigo-600 hover:text-indigo-800 font-medium inline-flex items-center"
            >
              Get Started <span className="ml-1">→</span>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Home;
